import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useSupportSession } from "@/contexts/SupportSessionContext";

/**
 * Support Mode scope guard.
 *
 * While a Support Session is active the Super Admin is acting as the selected
 * company's administrator, so every platform-wide / cross-company route is out
 * of scope and redirects back to the customer dashboard.
 *
 * Exiting the session clears the store before navigating, so this can never
 * trap the admin outside the Super Admin portal.
 */
export const SupportScopedRoute = ({ children }: { children: ReactNode }) => {
  const { isSupportSession } = useSupportSession();

  if (isSupportSession) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
